import { Text } from "@ui-kitten/components";
import { useAppSelector } from "hooks/useAppSelector";
import React from "react";
import { View } from "react-native";
import { formatCurrency } from "utils/appUtils";
import { getSinglePrice, planIdProperty } from "../helpers";

const OrderSummary = () => {
  // quantity is the primary member's quantity
  const { selectedCmsPlan, quantity, signupCharges } = useAppSelector(
    (state) => state.shopPagePhaseTwo
  );
  const { selectedBillingInterval, secondaryUsers } = useAppSelector(
    (state) => state.buyFlow
  );

  const planPackageSignupCharge = signupCharges.find(
    (charge) =>
      charge.billingInterval === selectedBillingInterval &&
      charge.planPackageId === selectedCmsPlan?.[planIdProperty]
  );

  // Since we don't allow multiple quantities for secondary users, we can just add the length of the secondary users array to the primary user's quantity
  // In a RESERVATION context, the total quantity would be 1 + secondaryUsers.length
  // In a VOUCHER context, the total quantity would always be primary member's quantity
  // In a BANK context, the total quantity would always be 1
  const totalQuantity = quantity + secondaryUsers.length;

  const SummaryDetails = () => (
    <>
      <View className="border-b-4 border-b-slate-900 pb-2">
        <Text category="h1" style={{ textAlign: "center" }}>
          ORDER SUMMARY
        </Text>
      </View>
      <View className="my-4 flex-row justify-between">
        <span className="text-xl">{selectedCmsPlan?.name}</span>
        {planPackageSignupCharge?.signupCharge && (
          <div>
            <div className="font-bold">
              {formatCurrency(
                getSinglePrice(planPackageSignupCharge.signupCharge)
              )}
            </div>
            <div className="text-xs italic text-gray-500">
              {selectedBillingInterval === "FULL_SEASON"
                ? "Pay In Full"
                : "Payment Plan"}
            </div>
          </div>
        )}
      </View>
      <View className="flex-row justify-between">
        <span className="justify-self-end text-right">Quantity:</span>
        <span className="font-bold">{totalQuantity}</span>
      </View>
      {planPackageSignupCharge?.signupCharge && (
        <View className="flex-row justify-between">
          <span className="font-bold">Total:</span>
          <span className="font-bold">
            {formatCurrency(
              Number(getSinglePrice(planPackageSignupCharge.signupCharge)) *
                totalQuantity
            )}
          </span>
        </View>
      )}
    </>
  );

  return (
    <View
      className="py-4 px-6 rounded-xl h-full"
      style={{ backgroundColor: "#ececec" }}
    >
      <SummaryDetails />
    </View>
  );
};

export default OrderSummary;
